<template>
  <pagination
    :name="name"
    :show-page-buttons="showPageButtons"
    :pages-count="pagesCount"
    :page="currentPage"
    @change="onPagerChange"
  />
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import Pagination from './pagination.vue';

  @Options({
    name: 'product-list-pagination',
    components: {Pagination}
  })
  export default class ProductListPagination extends Vue {
    @Prop()
    name: string;

    @Prop({type: Boolean, default: true})
    showPageButtons: boolean;

    @Prop({type: Number})
    pagesCount: number;

    @Prop({type: Number})
    currentPage: number;

    onPagerChange(page: number) {
      const newPage = page - 1;
      if (location.href.indexOf('page=') > -1) {
        location.href = location.href.replace(/page=([0-9]+)/, `page=${newPage}`);
      }
      else {
        location.href = location.href + `&page=${newPage}`;
      }
    }
  }
</script>
